
import { defineComponent, ref, reactive, inject, onMounted, watch } from "vue";
import { Request } from "@/api/request";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "WorksheetRequired",
    setup() {
        let tableData = ref([]),
            showData = ref([]),
            loading = ref(false),
            headClass = inject("headClass"),
            dialogVisible = ref(false),
            columnList = ref([]),
            form: any = reactive([]),
            checkboxChange = (status: number, key: string, index: number,basicset_id:number) => {
                if(status == 1){
                    let indexs = form[key].ids.findIndex((id:number) => id == basicset_id);
                    form[key].ids.splice(indexs,1)
                }else{
                    form[key].ids.push(basicset_id)
                }
                form[key].value[index] = status == 0 ? 1 : 0;
            },
            getTableData = (): void => {
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Operate/workRequiredList",
                    data: {},
                }).then((res: any) => {
                    loading.value = false;
                    if (res.status == 200) {
                        tableData.value = res.content.list.value;
                        showData.value = res.content.list.data;
                        columnList.value = res.content.list.column;
                        tableData.value.forEach((item: any) => {
                            let value:any = [],
                                ids:any = [];
                            item.list.forEach((items:any) => {
                                if(items.status == 1){
                                    ids.push(items.basicset_id)
                                }
                                value.push(items.status)
                            });
                             form[item.setitem_id] = {
                                 value,
                                 ids
                             }
                        });
                        console.log(form)
                    }
                });
            },
            onSubmit = () => {
                let list: any = [];
                Object.keys(form).forEach(setitem_id => {
                    list.push({
                        setitem_id,
                        basicset_id: form[setitem_id].ids.join(','),
                    });
                });
                Request.axiosInstance({
                    url: "adminapi/Operate/setWorkRequired",
                    data: {
                        list,
                    },
                }).then((res: any) => {
                    getTableData();
                    dialogVisible.value = false;
                    // selectData.value = res?.content?.list || [];
                });
            };
        onMounted(() => {
            getTableData();
        });
        return {
            columnList,
            loading,
            tableData,
            showData,
            dialogVisible,
            form,
            checkboxChange,
            onSubmit,
        };
    },
});
